import React from "react";
import createSvgIcon from "@material-ui/icons/esm/utils/createSvgIcon";

export default createSvgIcon(
  React.createElement("path", {
    d:
      "M3 7h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 11h8v-2H3v2zM3 15h5v-2H3v2zm13 0h5v-2h-5v2zM3 19m6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2z",
  }),
  "Timeline",
);
